export default {
  admin: "admin",
  app: "app",
};
